<template>
  <fieldset class="card">
    <h3 class="icon-heading tiny">
      <span class="icon"><svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-object-location"></use></svg></span>
      <span class="icon-heading-title">
        <span class="title">Lokasjon</span>
      </span>
    </h3>

    <dl>
      <dt>Nåværende lokasjon</dt>
      <dd>{{objekt.lokasjon ? objekt.lokasjon.Lokasjonkode : '-'}}</dd>

      <dt>Forrige lokasjon</dt>
      <dd>{{objekt.Sistelokasjon || '-'}}</dd>
    </dl>
  </fieldset>
</template>

<script>

export default {
  name: 'KundeKontraktObjektTabKjoperLokasjon',
  props: {
    objekt: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektTabKjoperLokasjon.vue